import { Badge } from '@indipia/ui-core';
import { badgeText } from './format';

export type DashboardTabKey = 'PHOTO' | 'SCHEDULE' | 'REPORT';

export interface DashboardTabItem {
  key: DashboardTabKey;
  label: string;
  /** 직전 방문 이후 새 소식 건수 — 0이면 배지를 그리지 않는다. */
  unread: number;
}

interface Props {
  tabs: DashboardTabItem[];
  active: DashboardTabKey;
  onChange: (key: DashboardTabKey) => void;
}

/**
 * 고객대시보드 전용 탭바 — 탭 라벨에 미열람 건수 배지를 함께 그린다(공용 Tabs는 라벨이 문자열 전용이라 쓰지 않음).
 * 배지는 강조색(파랑 바탕·흰 글씨)이며 탭을 열어도 이번 방문 동안 유지된다 — 다시 들어오면 직전 방문 기준이 갱신돼 사라진다.
 */
export function DashboardTabs({ tabs, active, onChange }: Props) {
  return (
    <nav role="tablist" aria-label="공유 내용" className="flex border-b border-border bg-surface-raised">
      {tabs.map((t) => {
        const selected = t.key === active;
        return (
          <button
            key={t.key}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={() => onChange(t.key)}
            className={[
              'flex flex-1 items-center justify-center gap-02 whitespace-nowrap border-b-2 px-02 py-04 text-caption font-bold transition-colors',
              selected ? 'border-info text-info' : 'border-transparent text-text-disabled',
            ].join(' ')}
          >
            {t.label}
            {t.unread > 0 && (
              <Badge status="accent" aria-label={`새 소식 ${t.unread}건`}>
                {badgeText(t.unread)}
              </Badge>
            )}
          </button>
        );
      })}
    </nav>
  );
}
